import { gql } from '@apollo/client';

export default gql`
  query bookingsWithWheelchairOrSpecialAssistance($date: String!, $station: String!) {
    bookingsWithWheelchairOrSpecialAssistance(date: $date, station: $station) {
      reference
      trains
      coachSeat
      specialAssistance
      customerFirstName
      customerLastName
      departingOn
      departingFrom
      departingTo
    }
  }
`;
